import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { setLETimeExpired } from '../../../redux/product/product.actions';
import { expirationDateForLimitedEditionSelector, isInStockLessThanMinQtySelector } from '../../../redux/product/product.selectors';
import { LimitedEditionCountdownComponent } from './limited-edition-countdown';
const mapStateToProps = createStructuredSelector({
  expirationDate: expirationDateForLimitedEditionSelector,
  isOutOfStock: isInStockLessThanMinQtySelector
});
const mapDispatchToProps = dispatch => ({
  onTimerEnd: () => dispatch(setLETimeExpired())
});
export const LimitedEditionCountdown = connect(mapStateToProps, mapDispatchToProps)(LimitedEditionCountdownComponent);